/**
 * TanStack Query Configuration
 * Global: NO cache for admin app (fresh data on every navigation).
 * Exception: Dashboard only - cached for better chart performance.
 */

// Time constants in milliseconds
export const TIME = {
  SECOND: 1000,
  MINUTE: 60 * 1000,
  HOUR: 60 * 60 * 1000,
};

/**
 * Global default options - NO cache for all queries.
 * Ensures navigating between pages never reuses cached data.
 */
export const DEFAULT_QUERY_OPTIONS = {
  staleTime: 0,
  gcTime: 0,
  refetchOnMount: true,
  refetchOnWindowFocus: true,
  retry: 1,
} as const;

/**
 * Dashboard-only exception: cache for better chart performance.
 * Use with query key: ['dashboard-founder', { startDate, endDate, merchantId, compare, ... }]
 */
export const DASHBOARD_FOUNDER_QUERY_OPTIONS = {
  staleTime: 60 * TIME.SECOND, // 60_000
  gcTime: 5 * TIME.MINUTE, // 5 * 60_000
} as const;

/**
 * Dashboard founder query key factory.
 * Must include all filters for proper cache isolation.
 */
export type DashboardFounderFilters = {
  startDate: string;
  endDate: string;
  merchantId?: string;
  compareWithPrevious?: boolean;
  city?: string;
  zone?: string;
  paymentMethod?: string;
};

export function dashboardFounderQueryKey(
  subKey: string,
  filters: DashboardFounderFilters
) {
  return ['dashboard-founder', subKey, filters] as const;
}
